import React from "react";

export default function DefaultResultItem({
                                            path,
                                            title,
                                            field_show_session_track,
                                            field_show_session_type: {name: type = ""} = {},
                                            field_speakers,
                                            field_show_session_location: location = "",
                                            session_date: eventDate = "",
                                            body: eventDescription = ""
                                          }) {
  let track = "";
  field_show_session_track.forEach((t, index) => {
    if (index === 0) {
      track = t.name;
    } else {
      track += ', ' + t.name;
    }
  });
  const speakers = field_speakers ?? [];
  // remove type per client request
  // const typeAndTrack = `${type}${type && track ? " | " : ""}${
  //   track ? `TRACK: ${track}` : ""
  // }`;
  const typeAndTrack = `${
    track ? `TRACK: ${track}` : ""
  }`;
  location = location.replace('&nbsp;', '').replace('&amp;', '&');
  title = title.replace('&nbsp;', '').replace('&amp;', '&');

  const handleAccordion = (theIndex) => {
    const button = document.querySelector('#' + theIndex)
    const panel = button.closest(".accordion-panel");
    const panelBody = panel.querySelector(".accordion-panel--body");
    const panelTitle = panel.querySelector(".accordion-panel--title");
    const futureAriaValue = panelBody.classList.contains("hidden").toString();
    panelBody.classList.toggle("hidden");
    panelTitle.parentNode.classList.toggle("border-b");
    panelTitle.setAttribute("aria-expanded", futureAriaValue);
  };
  const speakerList = speakers.map((speaker, index) => {
    const buttonIndex = "panel-id-" + index + Math.floor((Math.random() * (100000 - 1) + 1));
    return (
      <div className="accordion-panel" key={speaker.field_planstone_id + index}>
        <div className="border-b border-gray-400">
          <button
            id={buttonIndex}
            aria-expanded="false"
            aria-controls="panel-controlled"
            className="accordion-panel--title w-full text-left py-2 pl-0">
            <span className="accordion-panel--title__law block text-lg text-primary pr-8 font-bold relative" onClick={() => handleAccordion(buttonIndex)}>{speaker.name}</span>
          </button>
        </div>
        <div
          id="panel-controlled"
          aria-labelledby="panel-id"
          role="region"
          className="accordion-panel--body pr-4 hidden">
          <div className="max-w-3xl text-gray-700">
            <div className="container">
              <div className="flex flex-row gap-6">
                {!!speaker.field_picture_link ? (
                  <img className="rounded-3xl self-center w-1/4" src={speaker.field_picture_link} alt={speaker.name}/>
                ) : null}
                <div className="my-6 py-2 border-t border-b flex flex-col w-3/4">
                  <div className="text-nada-primary text-xs uppercase my-2">Presenter</div>
                  <div className="flex flex-col gap-4 justify-between h-full">
                    <div className="text-gray-700">
                      <div>
                        <h3>{speaker.name}</h3>
                        <div className="pt-1">{speaker.field_company}</div>
                        <div className="pt-1">{speaker.field_title}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="pt-2 pb-4">
                  {speaker.field_bio}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  });
  return (
    <div className="mb-8 max-w-2xl a-session-item">
      {!!typeAndTrack ? (
        <span className="text-primary text-xs font-bold uppercase">
					{typeAndTrack}
				</span>
      ) : null}
      {!!title ? (
        <h3>
          <a
            href={path}
            className="block mt-2 mb-4 text-black text-xl no-underline font-bold"
          >
            {title}
          </a>
        </h3>
      ) : null}
      {eventDate && (
        <div
          className="text-gray-700"
          dangerouslySetInnerHTML={{__html: eventDate}}
        />
      )}
      {location && (
        <div className="text-gray-700">
          <strong>Room: </strong>
          {location}
        </div>
      )}
      {eventDescription && (
        <div className="text-gray-700">
          <strong>Summary: </strong>
          <div
            className="text-gray-700"
            dangerouslySetInnerHTML={{__html: eventDescription}}
          />
        </div>
      )}
      {!!speakers.length && (
        <div className="text-gray-700">
          <div><strong>Presenters: </strong></div>
          {speakerList}
        </div>
      )}
    </div>
  );
}
